/**
 * Create an object getter and setter methods
 */
export function createGetSet(initial = {}): GetSet {
  const obj = initial;

  return { get, set };

  /**
   * Get a parameter or parameters.
   */
  function get(key?: string): any {
    return key ? obj[key] : obj;
  }

  /**
   * Set extended parameters by assigning to the extended object.
   */
  function set(o: any): void {
    Object.assign(obj, o);
  }
}

export interface GetSet<T = any> {
  get: (key?: T) => any;
  set: (o: Record<string, any>) => void;
}
